(() => {
  if (window.location.pathname !== '/') return;

  const selectors = ['.vv-about__art', '.mp-split .mp-image-panel'];
  const particles = [
    ['8%', '7px', '7.6s', '-1.2s', '16px'],
    ['19%', '5px', '9.2s', '-6.8s', '-12px'],
    ['31%', '8px', '8.4s', '-3.9s', '20px'],
    ['44%', '4px', '10.1s', '-8.1s', '-16px'],
    ['57%', '6px', '8.8s', '-2.5s', '12px'],
    ['69%', '5px', '9.7s', '-7.4s', '-18px'],
    ['81%', '8px', '7.9s', '-4.8s', '17px'],
    ['92%', '4px', '10.5s', '-9.2s', '-10px']
  ];

  document.querySelectorAll(selectors.join(',')).forEach((container) => {
    if (!container.querySelector(':scope > img')) return;

    container.classList.add('vv-home-image-motion');
    container.querySelector(':scope > .vv-home-image-sparkles')?.remove();
    container.querySelector(':scope > .vv-home-image-glitter')?.remove();

    const glitter = document.createElement('span');
    glitter.className = 'vv-home-image-glitter';
    glitter.setAttribute('aria-hidden', 'true');

    particles.forEach(([left, size, duration, delay, drift]) => {
      const flake = document.createElement('i');
      flake.className = 'vv-home-image-flake';
      flake.style.setProperty('--vv-left', left);
      flake.style.setProperty('--vv-size', size);
      flake.style.setProperty('--vv-duration', duration);
      flake.style.setProperty('--vv-delay', delay);
      flake.style.setProperty('--vv-drift', drift);
      glitter.appendChild(flake);
    });

    container.appendChild(glitter);
  });
})();
